export default __webpack_public_path__ + "images/CB.27b6cba.png";